import React from 'react'
import { FormikProps, useFormikContext } from 'formik'
import { BoxV4 } from '@labrav/react-components'
import { Typography } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faListCheck } from '@fortawesome/pro-regular-svg-icons'
import { CustomMetaDataV2 } from '../../../../common/components/CustomMetaDataV2/CustomMetaDataV2'
import { useStyles } from './CustomMetaData.styles'
import {
  MicrosoftFormFAQs,
  MicrosoftFormFAQsItem,
} from '../MicrosoftFormFAQs/MicrosoftFormFAQs'
import { Product } from '../../../../modules/productsListing/types'

export const CustomMetaData = ({ product }: { product: Product }) => {
  const formikProps = useFormikContext() as FormikProps<Record<string, unknown>>

  const { classes } = useStyles()

  return (
    <div data-testid="Custom-metadata-section">
      <BoxV4
        heading={'Custom metadata'}
        headingIcon={
          <FontAwesomeIcon
            icon={faListCheck}
            style={{ width: '16px', height: '16px' }}
          />
        }
        isOptional={true}
        secondaryActions={
          <MicrosoftFormFAQs item={MicrosoftFormFAQsItem.META_DATA} />
        }
      >
        <div className={classes.wrapper}>
          <CustomMetaDataV2
            product={
              {
                productId: product.productId,
                productName: product.productName,
              } as React.ComponentProps<typeof CustomMetaDataV2>['product']
            }
            subHeading={
              <Typography className={classes.sectionText}>
                Add a key-value pair to group or identify this offer for
                reporting purposes.
              </Typography>
            }
            size="small"
            formik={
              formikProps as unknown as FormikProps<Record<string, unknown>>
            }
            addButtonName={'Add more custom metadata'}
          />
        </div>
      </BoxV4>
    </div>
  )
}
